import { render, staticRenderFns } from "./InformeTecnicos.vue?vue&type=template&id=390c988c"
import script from "./InformeTecnicos.vue?vue&type=script&lang=js"
export * from "./InformeTecnicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports